
import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"
import Modal from "app/modal/show-modal"
import ListingSearchShareBox from "concepts/listings/share/box/index"


import I18n from "plugins/i18n-js"
import * as Routes from "plugins/js-routes"


const init = ({listing_id}: {listing_id: string | number}): void => {
  return q_ajax_3({
    url:      Routes.apps_spacious_website_partials_single_overseas_residential_project_share_modal_path({
      locale:     I18n.locale,
      listing_id: listing_id,
    }),
    method:   "GET",
    dataType: "html",
  })
  .then(({data}) => {
    Modal.hideTopModal()
    Modal.showModalWithContent(data)
    ListingSearchShareBox.create()
  })
  .done()
}

export { init }
